<!--
附带协作区树的公共面板组件
-->
<template>
<x-tree-panel :data="coordinatedData" :treeWidth="treeWidth" ref="zcs" style="width:400px !important;height: 100%;" @selected="onSelect">
  <slot></slot>
</x-tree-panel>
</template>
<script>
  import { httpAction, getAction } from '@/api/manage'
  import XTreePanel from '@/components/xdhm/XTreePanel'

  export default {
    name: 'XDepartPanel',
    components: {
      XTreePanel
    },
    props:{
      treeWidth:{
        type: Number,
        default: 5
      }
    },
    data() {
      return {
        coordinatedData: [],
        url:{
          getTree:''
        },
        firstDx:{},
        cshzt:false
      }
    },
    created(){
      this.$nextTick(() => {
        this.refresh();
      })
    },
    methods: {
      callback(key) {
        //console.log(key)
      },
      loadTree() {
        var that = this
        that.coordinatedData = []
        if(''==that.url.getTree){
          that.$message.warning("请确认访问链接是否正确！");
          return false;
        }
        getAction(that.url.getTree,null).then((res) => {
          if (res.success && res.result ) {
            for (let i = 0; i < res.result.length; i++) {
              if(i==0){
                that.firstDx=res.result[i];
              }
              let temp = res.result[i]
              that.coordinatedData.push(temp)
            }
            // that.coordinatedData = [];
            this.loading = false
          }
          that.userIdentity = res.message
          //that.onSelect(that.firstDx);
          that.$refs.zcs.selectedKeys = [that.firstDx.id];
          that.cshzt = true;
          that.$emit('treeDataLoaded',that.firstDx);
        })
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },
      onSearch(value) {
        let that = this
        // if (value) {
        //   getAction("/yqfk/coordinatedregions/searchBy",{keyWord: value}).then((res) => {
        //     if (res.success) {
        //       that.departTree = []
        //       for (let i = 0; i < res.result.length; i++) {
        //         let temp = res.result[i]
        //         that.departTree.push(temp)
        //       }
        //     } else {
        //       that.$message.warning(res.message)
        //     }
        //   })
        // } else {
          that.loadTree()
        // }

      },
      onSelect(selectedNode) {
        console.info();
        this.$emit('selected', selectedNode.record);
      },
      uptTreeData(departData){
        this.coordinatedData=departData;
      }
    },
    created() {
      let that = this;
      that.url.getTree='/sys/sysDepart/queryMyDeptTreeList';
      that.loadTree();
    },
  }
</script>
<style scoped>
  /* @import '~@assets/less/common.less' */
</style>